var map = {
	"./adobexd.webp": 32559,
	"./aftereffects.webp": 49796,
	"./agile-software.webp": 89214,
	"./ai-chat.webp": 42423,
	"./ai-development.webp": 73178,
	"./ai-icon.webp": 69276,
	"./ai-ml-develop.webp": 9352,
	"./alibaba.webp": 56808,
	"./android-app.webp": 39121,
	"./android-right.webp": 58300,
	"./angular.webp": 9842,
	"./ansible.webp": 3556,
	"./apache.webp": 71238,
	"./apple.webp": 89784,
	"./arrow.webp": 14565,
	"./aws.webp": 22729,
	"./backend-icon.webp": 38314,
	"./blender.webp": 13944,
	"./blockchain-icon.webp": 9568,
	"./bootstrap.webp": 60778,
	"./branding.webp": 46499,
	"./brownie.webp": 79410,
	"./burp-suite.webp": 47818,
	"./c-program.webp": 39040,
	"./cardIcon.png": 16111,
	"./cardIcon.webp": 12051,
	"./cassandra.webp": 78366,
	"./chef.webp": 27668,
	"./circleci.webp": 98316,
	"./cloud-icon.webp": 10153,
	"./computer-vision.webp": 98636,
	"./contact-img.svg": 32498,
	"./contact-line-one.webp": 55056,
	"./contact-line-two.webp": 75538,
	"./contact-temple.svg": 49954,
	"./content-marketing.webp": 31712,
	"./cplus-bg.webp": 99663,
	"./cplus.webp": 59733,
	"./cprogram-bg.webp": 25781,
	"./crm.webp": 99148,
	"./crypto-payment.webp": 50982,
	"./crypto-token.webp": 98221,
	"./css.webp": 59159,
	"./cucumber.webp": 39884,
	"./custom-software.webp": 38771,
	"./custom-trading.webp": 9059,
	"./database-icon.webp": 21773,
	"./design-icon.webp": 20804,
	"./devops-icon.webp": 15521,
	"./digital-ocean.webp": 7603,
	"./dl.webp": 39408,
	"./docker.webp": 99988,
	"./dynamo.webp": 36030,
	"./erp-software.webp": 66465,
	"./explore-head-img.webp": 85714,
	"./figma.webp": 48508,
	"./flutter.webp": 75970,
	"./fogbugz.webp": 54336,
	"./forex-algorithm.webp": 41590,
	"./forex-trading-app.webp": 75228,
	"./frontend-icon.webp": 58057,
	"./gemini.webp": 35351,
	"./generative-ai.webp": 70867,
	"./git.webp": 44440,
	"./go-bg.webp": 36782,
	"./go.webp": 4538,
	"./googlecloud.webp": 8220,
	"./grafana.webp": 82952,
	"./granche.webp": 89552,
	"./hardhat.webp": 76198,
	"./hero-curve.webp": 92002,
	"./html.webp": 98633,
	"./hyperleadger.webp": 82930,
	"./ibm.webp": 49574,
	"./ico.webp": 97265,
	"./illustrator.webp": 87361,
	"./ionic.webp": 83174,
	"./ios-app.webp": 56963,
	"./jenkins.webp": 74574,
	"./jira.webp": 97444,
	"./kafka.webp": 650,
	"./keras.webp": 61282,
	"./kubernetes.webp": 9772,
	"./landing-mail.webp": 34837,
	"./landing-phone.webp": 48374,
	"./landing-telegram.webp": 48033,
	"./landing-whatsapp.webp": 76096,
	"./laravel.webp": 7177,
	"./maya.webp": 99640,
	"./memcache.webp": 94101,
	"./microservice.webp": 65263,
	"./microsoftazure.webp": 63027,
	"./migration.webp": 84204,
	"./ml.webp": 89861,
	"./mobile-app-icon.webp": 21822,
	"./mongo.webp": 20928,
	"./mt.webp": 78701,
	"./mysql.webp": 53485,
	"./nearshore-software.webp": 20183,
	"./next.webp": 64973,
	"./nft.webp": 94320,
	"./nlp.webp": 65482,
	"./node-bg.webp": 28207,
	"./node.webp": 56308,
	"./nuxt.webp": 43293,
	"./offshore-development.webp": 68822,
	"./openai.webp": 65146,
	"./opencv.webp": 55841,
	"./oracle.webp": 19190,
	"./photoshop.webp": 19520,
	"./php.webp": 56960,
	"./postgre.webp": 52946,
	"./postman.webp": 19386,
	"./progressive-app.webp": 98649,
	"./prometheus.webp": 61880,
	"./protractor.webp": 43222,
	"./puppet.webp": 34010,
	"./pwa.webp": 15508,
	"./python-bg.webp": 18898,
	"./python.webp": 32102,
	"./pytorch.webp": 49151,
	"./rabbitmq.webp": 90614,
	"./react-native.webp": 19229,
	"./react.webp": 52079,
	"./redis.webp": 97491,
	"./reinforcement.webp": 70493,
	"./ruby-bg.webp": 18320,
	"./ruby.webp": 7952,
	"./rust-bg.webp": 47566,
	"./rust.webp": 29050,
	"./scikit.webp": 76535,
	"./selenium.webp": 14884,
	"./seo.webp": 62429,
	"./sketch.webp": 1460,
	"./smart-contract.webp": 48938,
	"./solidity.webp": 11181,
	"./spline.webp": 71581,
	"./svelte.webp": 93975,
	"./tech-right-angular.webp": 35184,
	"./tech-right-css.webp": 54773,
	"./tech-right-html.webp": 23759,
	"./tech-right-next.webp": 287,
	"./tech-right-nuxt.webp": 3503,
	"./tech-right-react.webp": 86897,
	"./tech-right-svelete.webp": 46410,
	"./tech-right-vue.webp": 88270,
	"./techstack-grid.webp": 34963,
	"./techstack-gridtwo.webp": 88075,
	"./techstack-lineOne.webp": 13799,
	"./techstack-lineTwo.webp": 7053,
	"./tensorflow.webp": 33981,
	"./testing-icon.webp": 17326,
	"./testng.webp": 339,
	"./trading-bot.webp": 36437,
	"./truffle.webp": 77926,
	"./vue.webp": 75571,
	"./web-app.webp": 14880
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 59388;